import { createContext } from 'react';
import { SupplierListModel } from '../components/supplier/type';
import { SearchCardSubMsg } from '../types';

export type SupplierCardContextValue = SupplierListModel & {
  subMsgData: SearchCardSubMsg;
  /**
   * 已经选择的供应商数量
   */
  selectedCount: number;
};

/**
 * 供应商卡片消息卡片store
 */
export const SupplierCardContext = createContext<SupplierCardContextValue>({} as SupplierCardContextValue);
